import AppLoading from './components/AppLoading';
import React from 'react';
import ReactDOM from 'react-dom/client';
const App = process.env.NODE_ENV === 'development' && window.location.pathname === '/review-preview'
  ? React.lazy(() => import('./preview/ReviewPreview'))
  : React.lazy(() => import('./App'));

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(<React.StrictMode><React.Suspense fallback={<AppLoading />}><App /></React.Suspense></React.StrictMode>);

// Register service worker for PWA
if (process.env.NODE_ENV === 'production' && 'serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    navigator.serviceWorker.register('/service-worker.js')
      .then(reg => console.log('SW registered:', reg.scope))
      .catch(err => console.log('SW registration failed:', err));
  });
}
